import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import { ColumnModel } from '@syncfusion/ej2-angular-grids';
import * as _ from 'underscore';
import { ErrorService } from '../../../../../@core/utils/error.service';
import { lotInventory, lotInventoryService } from '../../../laboratory/services/lab-quantity-service';
import { InventoryService } from '../../../pick-plan/services/inventory.service';
import { HandlingUnitMasterDTO } from '../../models/handling-unit-master';
import { LotDetailsByRoomActionComponent } from '../lot-details-by-room-action/lot-details-by-room-action.component';
import { LotDetailsByRoomDialogComponent } from './lot-details-by-room-dialog/lot-details-by-room-dialog.component';
import { LotDetailsByRoomMoveInventoryComponent } from './lot-details-by-room-move-inventory/lot-details-by-room-move-inventory.component';
import { KW_QUANTITY_FORMAT } from '../../../../../@core/utils/ejs-constants';

export interface GroupedLot {
  lotNumber: string;
  receiptDate: Date;
  quantity: number;
}
@Component({
  selector: 'lot-details-by-room',
  templateUrl: './lot-details-by-room.component.html',
  styleUrls: ['./lot-details-by-room.component.scss']
})
export class LotDetailsByRoomComponent implements OnInit {
  @ViewChild('actionTemplate', { static: true }) public actionTemplate: any;

  @Output() refreshTable = new EventEmitter<boolean>();

  public isLoading: boolean = true;

  public allHums: HandlingUnitMasterDTO[] = [];
  private destroyRef = inject(DestroyRef);

  @Input() roomId: number;
  @Input() blockId: number;
  @Input() farmId: number;
  @Input() cropYearId: number;
  @Input() varietyId: number;

  public lots: GroupedLot[] = [];
  public faEllipsisVertical = faEllipsisVertical;
  public columns: ColumnModel[] = [];

  constructor(
    private inventoryService: InventoryService,
    private errorService: ErrorService,
    public dialog: MatDialog,
    private lotInventoryService: lotInventoryService,
  ) {

  }

  ngOnInit() {
    this.columns = [
      { field: 'lotNumber', headerText: 'Lot #' },
      { field: 'receiptDate', headerText: 'Date', format: { type: 'dateTime', skeleton: 'short' } },
      { field: 'quantity', headerText: 'Qty', format: KW_QUANTITY_FORMAT, textAlign: 'Right', width: 110 },
      { headerText: '', template: this.actionTemplate, width: 64, textAlign: 'Center', allowSorting: false }
    ];
    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    this.inventoryService.getInventoryHUMs(false, null, null, null, this.roomId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:(data) => {
      this.allHums = data;

      let huds = this.allHums.flatMap(hum => hum.handlingUnitDetails);

      let filteredHuds = huds.filter(hud =>
        hud.blockId == this.blockId &&
        hud.farmId == this.farmId &&
        hud.varietyId == this.varietyId &&
        hud.isActive
      );

      // group huds by lot information
      let groupedHuds = _.groupBy(filteredHuds, hud => hud.lotNumber);

      this.lots = [...Object.keys(groupedHuds).map(key => {
        let huds = groupedHuds[key];
        let quantity = huds.reduce((acc, hud) => acc + hud.quantity, 0);
        return {
          lotNumber: key,
          lotId: huds[0].lotId,
          receiptDate: new Date(huds[0].createdDate),
          handlingUnitDetailId: huds.map(hud => hud.id),
          handlingUnitMasterId: huds.map(hud => hud.handlingUnitMasterId),
          quantity: quantity
        };
      })];


      this.isLoading = false;
    }, error:error => {
      this.isLoading = false;
    }});
  }


  public actionsClicked(args: GroupedLot): void {

    let data: lotInventory = args;

    data.originalQuantity = args.quantity;
    LotDetailsByRoomActionComponent.open(this.dialog, { lotNumber: args.lotNumber }).afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((val) => {
      if (val == 'adjust') {

        this.dialog.closeAll();

        LotDetailsByRoomDialogComponent.open(this.dialog, data).afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((val: lotInventory) => {
          if (val) {
            let adjustmentQuantity = val.quantity - val.originalQuantity;

            
            if (adjustmentQuantity > 0) {
              val.quantity = Math.abs(adjustmentQuantity);
              this.lotInventoryService.lotInventoryAdd(val).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x => {
                this.refreshTable.emit(true);
              });
            } else {
              val.quantity = Math.abs(adjustmentQuantity);

              this.lotInventoryService.lotInventoryRemove(val).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x => {
                this.refreshTable.emit(true);
              });
            }            
          }

        });
      }
      else if (val == 'move') {
        this.dialog.closeAll();
        let moveData = {
          lot: args,
          isPopup: true,
          type: "transfer",
          lotId: data.lotId,
          lotName: args.lotNumber,
        };

        LotDetailsByRoomMoveInventoryComponent.open(this.dialog, moveData).afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(job => {
          if (job == 'reload')
            this.refreshTable.emit(true);
        });
      }
      else {
        this.dialog.closeAll();
      }
    });

  }

}
